import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d85aa628&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d85aa628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85aa628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d85aa628')) {
      api.createRecord('d85aa628', component.options)
    } else {
      api.reload('d85aa628', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d85aa628&scoped=true&", function () {
      api.rerender('d85aa628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/comp/DocBox.vue"
export default component.exports